import {compose} from 'redux';
import withUsers from '../../../_common/components/Users/components/withUsers';
import VerticalTabs from './VerticalTabs';

export default compose(
  withUsers,
)(VerticalTabs);
